import * as Scrivito from "scrivito";
import cx from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { Icon } from "components/Icon/Icon";
import { useTranslate } from "hooks";
import s from "./LeftSidebar.module.scss";

const firstToggleButtonId = `left-sidebar-toggle-first`;
const secondToggleButtonId = `left-sidebar-toggle-second`;

type SidebarToggleProps = {
  setIsOpened: React.Dispatch<React.SetStateAction<boolean>>;
  isOpened: boolean;
  isFirstSidebar: boolean;
  text: string;
  onLeft: boolean;
  color: string;
  isRightSidebarToggle?: boolean;
};

export const SidebarToggle = Scrivito.connect(
  ({
    setIsOpened,
    isOpened,
    isFirstSidebar,
    text,
    onLeft = false,
    color = "primary",
    isRightSidebarToggle,
  }: SidebarToggleProps) => {
    const translate = useTranslate();

    const [offsetHeight, setOffsetHeight] = useState(0);

    const handleToggle = () => {
      setIsOpened(!isOpened);
      handleButtonPosition(!isOpened);
    };

    const handleButtonPosition = useCallback(
      (isSidebarOpened: boolean) => {
        if (!isFirstSidebar && !isSidebarOpened && !isRightSidebarToggle) {
          const toggleButton = document.getElementById(firstToggleButtonId);
          if (toggleButton) {
            setOffsetHeight(toggleButton.offsetHeight);
          }
        } else {
          setOffsetHeight(0);
        }
      },
      [isFirstSidebar, isRightSidebarToggle],
    );

    useEffect(() => {
      handleButtonPosition(isOpened);
    }, [isOpened, handleButtonPosition]);

    return (
      <div
        className={cx(s.toggleBtnContainer, {
          [s.toggleBtnContainerLeft]: onLeft,
          [s.toggleBtnContainerRight]: !onLeft,
          "bg-blue-300": color === "primary",
          "bg-gray-700": color === "secondary",
        })}
      >
        <div
          className={cx(
            "position-absolute d-flex px-2 py-3 text-white cursor-pointer gap-1",
            s.toggleBtn,
            {
              [s.toggleBtnLeft]: onLeft,
              [s.toggleBtnRight]: !onLeft,
              "bg-blue-300": color === "primary",
              "bg-gray-700": color === "secondary",
            },
          )}
          style={{ top: offsetHeight, transition: "top 0.4s ease" }}
          id={isFirstSidebar ? firstToggleButtonId : secondToggleButtonId}
          onClick={handleToggle}
        >
          <Icon
            iconName={
              isRightSidebarToggle === isOpened
                ? "chevron-right-regular"
                : "chevron-left-regular"
            }
          />
          <div className={cx("fw-semibold user-select-none", s.toggleBtnText)}>
            {translate(text)}
          </div>
        </div>
      </div>
    );
  },
);
